import script from "./wTextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./wTextButton.vue?vue&type=script&setup=true&lang=js"

import "./wTextButton.vue?vue&type=style&index=0&id=1e509292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e509292"]])

export default __exports__